import { Component, Input, Output, EventEmitter, OnChanges } from '@angular/core';
import { DataService } from '../../../data.service';


@Component({
  selector: 'lc-product-counter',
  templateUrl: './product-counter.component.html',
  styleUrls: ['./product-counter.component.scss']
})
export class ProductCounterComponent {

  @Input('product') selected_product: any;
  @Output() add: EventEmitter<any> = new EventEmitter();
  @Output() remove: EventEmitter<any> = new EventEmitter();

  total_products_amount: number = 0;

  constructor(public dataService: DataService) { }

  addItem(event){
    this.add.emit(1);
  }

  removeItem(event){
    this.remove.emit(-1);
  }

}



// WEBPACK FOOTER //
// /Users/matthijs/projects/PHILIPS/philips-dental-pro/shop/src/app/components/product/product-counter/product-counter.component.ts